<template>
	<div id="loginForm">

		<h3>
			Login
			<small class="text-muted">Entre com os seus dados para acessar seus exames</small>
		</h3>

		<br>

		<div class="alert" :class="{'alert-danger': credentials.callback.error, 'alert-success': !credentials.callback.error}" v-if="credentials.callback.message">{{credentials.callback.message}}</div>

		<form v-on:submit.prevent="submitLogin">
			<div class="form-group">
				<input type="text" v-mask="['###.###.###-##']" required class="form-control" v-model="credentials.login" name="login" ref="login" placeholder="Digite seu e-mail ou CPF" />
			</div>
			<div class="form-group">
				<input type="text" v-mask="'##/##/####'" required class="form-control" v-model="credentials.dtnasc" ref="datanasc" placeholder="Data de nascimento">
			</div>
			<button type="submit" class="btn btn-block btn-light-blue">Acessar</button>
		</form>
	</div>
</template>


<script>
	import {Auth} from '@/services'
	import moment from 'moment'

	export default {
		name: "loginFormPage",
		data() {
			return {
				credentials: {
					login: null,
					dtnasc: null,
					callback: {
						message: null,
						error: null
					}
				}
			}
		},
		methods: {
			submitLogin(ev) {
				this.credentials.callback.message = this.$t('Verifying') + '...';

				Auth.loginPatient({
					login: this.credentials.login,
					dtnasc: moment(this.credentials.dtnasc, 'DD/MM/YYYY').format('YYYY-MM-DD'),
					loginMethod: ''
				})
				.then((response) => {
					this.credentials.callback.error = false;
					this.credentials.callback.message = this.$t('PleaseWait');

					localStorage.setItem("Authorization", response.data.token);
					Auth.setToken(response.data.token);
				})
				.then(() => {
					Auth.setAuthenticated()
					.then(response => {
						this.$router.push({name: 'patientExams'})
					})
				})
				.catch((error) => {
					this.credentials.callback.error = true;
					this.credentials.callback.message = "Dados inválidos, tente novamente";
				})
			}
		}
	}

</script>

<style lang="scss">
#loginForm {
		padding: 8px;
		margin:32px 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/login/loginFormPage.vue